exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".labelMap{margin-bottom:60px;border:1px solid #eb3a44;border-radius:5px;background:#fee1d7;text-align:center;line-height:20px;font-weight:700;font-size:14px;color:#eb3a44}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4f26663d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Dashboard.vue
// module id = 320
// module chunks = 0